import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Stakeholder Group',
    type: 'text',
    width: 30,
  },
  {
    key: 'contactFirstName',
    header: 'Contact First Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'contactLastName',
    header: 'Contact Last Name',
    type: 'text',
    width: 30,
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    width: 40,
  },
  {
    key: 'phone',
    header: 'Phone',
    type: 'number',
  },
];
